import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { DOCUMENT_OUTGOING_PREFIX_URL } from './constants/config.document-outgoing'

const ListPageAll = lazy(() => import('./pages/ListPage.All.DocumentOutgoing'))
const ListPageMyCreated = lazy(
  () => import('./pages/ListPage.MyCreated.DocumentOutgoing')
)
const ListPageMyProcess = lazy(
  () => import('./pages/ListPage.MyProcess.DocumentOutgoing')
)
const ListPageWaitingApproval = lazy(
  () => import('./pages/ListPage.WaitingApproval.DocumentOutgoing')
)
const DetailPage = lazy(() => import('./pages/DetailPage.DocumentOutgoing'))
const ReportPage = lazy(() => import('./pages/Report.DocumentOutgoing'))

const DocumentOutgoingRouters: AppRouterItem[] = [
  {
    path: `${DOCUMENT_OUTGOING_PREFIX_URL}/report`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ReportPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_OUTGOING_PREFIX_URL}/all`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageAll />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_OUTGOING_PREFIX_URL}/my-created`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageMyCreated />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_OUTGOING_PREFIX_URL}/my-process`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageMyProcess />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_OUTGOING_PREFIX_URL}/waiting-approval`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageWaitingApproval />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_OUTGOING_PREFIX_URL}/report/:documentOutgoingId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_OUTGOING_PREFIX_URL}/all/:documentOutgoingId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_OUTGOING_PREFIX_URL}/my-created/:documentOutgoingId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_OUTGOING_PREFIX_URL}/my-process/:documentOutgoingId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_OUTGOING_PREFIX_URL}/waiting-approval/:documentOutgoingId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
]

export default DocumentOutgoingRouters
